export default __webpack_public_path__ + "static/media/anzacBiscuits.f848bc37.jpg";